import { ADD_PAYMENT_RAZORPAY, ADD_PHONE_PE, ADD_UPI_ID, GET_UPI_ID, GET_WALLET_DETAILS_URL, OFFLINE_NOTIFICATION, WITHDRAW_PAYMENT } from "../../api";
import axiosInstance from "../../axiosInstance";

export const getWalletDetails = () => onResponse => {
    try {
        axiosInstance.get(GET_WALLET_DETAILS_URL)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const addUPIID = (upi_id) => onResponse => {
    try {
        axiosInstance.post(ADD_UPI_ID, { upi_id })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const addPhonepe = (amount) => onResponse => {
    try {
        axiosInstance.post(ADD_PHONE_PE, { amount })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const getUpiIdData = () => onResponse => {
    try {
        axiosInstance.get(GET_UPI_ID)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                // onResponse(err);
            });

    } catch (error) {

    }

};
export const addPaymentRazorpay = (payment_id, amount) => onResponse => {
    try {
        axiosInstance.post(ADD_PAYMENT_RAZORPAY, { payment_id, amount })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const withdrawPayment = (amount) => onResponse => {
    try {
        axiosInstance.post(WITHDRAW_PAYMENT, { amount })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const offlineNotification = (data) => onResponse => {
    try {
        axiosInstance.post(OFFLINE_NOTIFICATION, data)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};